<template>
  <v-card tile flat>
    <v-toolbar v-if="title" dense flat class="one-row">
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="body-1"><b>{{ subtitle }}</b></v-card-text>

    <v-card-text class="body-1" v-html="text" />
    <v-card-text class="">
      <v-checkbox v-model="selected" :false-value="false" :true-value="true" :label="label"></v-checkbox>
    </v-card-text>
    <v-card-actions v-if="actions && Object.keys(actions).length" class="d-flex justify-end mt-n4">
      <template v-for="action in actions">
        <v-btn :disabled="action.disabled" @click="handleClick(action)" :key="action.text" :outlined="action.outlined">
          <v-icon v-if="action.icon">{{ action.icon }}</v-icon>
          {{ action.text }}
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import Confirmable from 'vuedl/src/mixins/confirmable'

export default {
  layout: ['default', {width: 450}],
  mixins: [Confirmable],
  props: {
    actionOptions: Object,
    title: String,
    subtitle: String,
    text: {
      type: String,
      required: true,
      default: ''
    },
    label: String
  },
  data: () => ({
    selected: false
  }),
  methods: {
    handleClick(data) {
      this.$emit('submit', {data: data.key, checkbox: this.selected})
    }
  }
}
</script>